export const isPasswordEqualOrGreaterThan = (password: string, numberOfCharacter: number) => {
  const regex = new RegExp(`(?=.{${numberOfCharacter},})`);
  return regex.test(password);
};

export const doesPasswordContainsNumericCharacters = (password: string) => {
  const regex = /(?=.*[0-9])/;
  return regex.test(password);
};

export const doesPasswordContainsUpperAndLowerCaseCharacters = (password: string) => {
  const regex = /(?=.*[a-z])(?=.*[A-Z])/;
  return regex.test(password);
};

export const doesPasswordContainsSpecialCharacters = (password: string) => {
  const regex = /[!@#$%^&*()\-_+=|{}[\]:;"'<>,.?/\\~]/;
  return regex.test(password);
};

// Cognito rejects passwords that start or end with whitespace (pattern ^[\S]+.*[\S]+$).
// Its \s only covers ASCII whitespace, so e.g. a non-breaking space is accepted.
export const doesPasswordStartOrEndWithWhitespace = (password: string) => {
  const regex = /^[ \t\n\v\f\r]|[ \t\n\v\f\r]$/;
  return regex.test(password);
};
